import { Box, Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid2, Radio, RadioGroup, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BASE_URL } from "../url";

const fee = 6.00

const StyledCard = styled(Card)({
    borderRadius: "0",
    width: "100%",
});
  
const StyledButton = styled(Button)({
    margin: "8px 0",
    textTransform: "none",
    borderRadius: "0",
    boxShadow: "none"
});

const StyledTableCell = styled(TableCell)({
    whiteSpace: 'nowrap'
})

// const bankAccounts = {
//     // "0": {
//     //     account_name: 'DPay Cash-Out Account',
//     //     account_number: '019-21-00074-8',
//     //     bank: '0'
//     // },
//     // "1": {
//     //     account_name: 'FSG Technology Ventures Inc',
//     //     account_number: '005 21 00115 0',
//     //     bank: '0'
//     // },
//     "2": {
//         account_name: 'FSG Technology Ventures Inc',
//         account_number: '0019 3000 1785',
//         bank: 'unionbank'
//     },
//     // "3": {
//     //     account_name: 'ZS FASTPRINT PHOTOCOPYING SERVICES',
//     //     account_number: '0014 1001 6850',
//     //     bank: '0041'
//     // },
//     // "4": {
//     //     account_name: 'RJS Automotive Parts',
//     //     account_number: '0021 9001 2552',
//     //     bank: '0041'
//     // },
//     "5": {
//         account_name: 'Direct Agent 5 Inc',
//         account_number: '0019 3000 8755',
//         bank: 'unionbank'
//     },
// }

const banks = {
    '0'   : 'Allbank',
    'unionbank': 'Unionbank'
}

type BankCode = '0' | 'unionbank'
type BankAccountIndex = '2' | '5' //| '3' | '4' | '0' | '1'

const Wallet = ({bankAccounts}: {bankAccounts: any[]}) => {
    const navigate = useNavigate();
    const token: any = JSON.parse(localStorage.getItem("token") || '{}');
    const [balance, setBalance] = useState(0);
    const [amount, setAmount] = useState(0);
    const [method, setMethod] = useState('');
    const [bankDetails, setBankDetails] = useState<any>();
    const [openOtp, setOpenOtp] = useState(false);
    const [remainingTime, setRemainingTime] = useState('00:00');
    const [confirmOtp, setConfirmOtp] = useState('');
    const [timer, setTimer] = useState<any>();
    const [loadingTransfer, setLoadingTransfer] = useState(false);

    const [error, setError] = useState('');

    const [logs, setLogs] = useState<any[]>([])
    const [startDate, setStartDate] = useState(moment().utcOffset('+0800').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().utcOffset('+0800').format('YYYY-MM-DD'));
    const [loadingLogs, setLoadingLogs] = useState(false)
    const [downloadingLogs, setDownloadingLogs] = useState(false)

    const [dialogDetails, setDialogDetails] = useState<any>();
    const [dialogTransactions, setDialogTransactions] = useState<any[]>([])

    const getBalance = () => {
        fetch(
            `${window.location.protocol}//${BASE_URL}/dashboard/wallet/balance`, {
            headers: {
                Authorization: `Bearer ${token.access_token}`
            }
        })
        .then(async resp => {
            if (resp.status == 200) {
                return await resp.json()
            } else {
                return 0
            }
        })
        .then(amount => {
            setBalance(+amount)
        })
        getLogs()
    }

    useEffect(getBalance, [])

    useEffect(() => {
        if (amount) {
            const fees = (bankDetails?.bank != '0' && method == 'instapay'? Math.ceil(amount/50000): 0)*fee
            setError(
                amount <= 0? 'Please enter amount':
                amount + fees > balance? 'Insufficient Amount': ''
            )
        }
    }, [amount, bankDetails?.bank, method])

    useEffect(() => {
        setMethod(
            bankDetails?.bank == '0'? 'intrabank':
            method == 'intrabank'? '':
            method
        )
    }, [bankDetails?.bank])

    const sendOtp = () => {
        const fees = (bankDetails?.bank != '0' && method == 'instapay'? Math.ceil(amount/50000): 0)*fee
        const error = (
            amount <= 0? 'Please enter amount':
            amount + fees > balance? 'Insufficient Amount': ''
        )
        setError(error)
        if (!bankDetails) {
            Swal.fire({
                title: 'Invalid',
                text: 'Please select a recipient',
                icon: 'error'
            })
        } else if (!error) {
            fetch(
                `${window.location.protocol}//${BASE_URL}/dashboard/wallet/transfer/send-otp`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token.access_token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    amount, method, bank_details: {
                        account_name  : bankDetails?.account_name,
                        account_number: bankDetails?.account_number,
                        bank_code     : bankDetails?.bank
                    }
                })
            }).then(resp => {
                if (resp.status == 200) {
                    setOpenOtp(true)
                }
                return resp.json()
            })
            // .then(data => {
            //     const targetDate = new Date(data.expiration).getTime();
            //     const timer = setInterval(() => {
            //         const now = new Date().getTime();
            //         const distance = targetDate - now;
            
            //         if (distance <= 0) {
            //             clearInterval(timer);
            //             setRemainingTime('00:00');
            //             setOpenOtp(false);
            //             Swal.fire({
            //                 title: 'OTP Expired',
            //                 text: 'Please submit new request'
            //             })
            //             return;
            //         }

            //         const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            //         const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            //         setRemainingTime(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
            //     });
            //     setTimer(timer);
            // })
        }
    }


    const verifyOtp = (otp: string) => {
        setLoadingTransfer(true)
        clearInterval(timer)
        setTimer(undefined)
        setOpenOtp(false)
        fetch(
            `${window.location.protocol}//${BASE_URL}/dashboard/wallet/transfer/confirm-otp`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token.access_token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({otp, amount, method, bank_details: {
                account_name  : bankDetails?.account_name,
                account_number: bankDetails?.account_number,
                bank_code     : bankDetails?.bank || bankDetails?.bank_code
            }})
        }).then(async resp => {
            if (resp.status == 200) {
                return resp.json()
            } else if (resp.status == 401) {
                Swal.fire({
                    title: 'Session Expired',
                    text: 'Please Login Again'
                }).then(() => {
                    localStorage.removeItem('token')
                    navigate('/login')
                })
            } else {
                return {ErrorMsg: JSON.stringify((await resp.json()).detail)}
            }
        })
        .then(data => {
            setOpenOtp(false)
            if (data?.ErrorMsg) {
                Swal.fire({
                    text: data.ErrorMsg,
                    icon: 'error'
                }).then(() => setOpenOtp(true))
            } else {
                Swal.fire({
                    title: 'Submitted Request',
                    text: 'Your transfer request is now in process. You may track the progress from the Wallet Logs.'
                }).then(() => {
                    getBalance()
                    getLogs()
                })
                clearInterval(timer);
            }
        })
        .finally(() => setLoadingTransfer(false))
    }

    const getLogs = (config: any = {download: false}) => {
        config.download? setDownloadingLogs(true): setLoadingLogs(true)
        let result: Promise<any> = fetch(
            `${window.location.protocol}//${BASE_URL}/dashboard/wallet/wallet-logs?start=${startDate}&end=${endDate}&download=${config.download}`, {
            headers: {
                Authorization: `Bearer ${token.access_token}`,
                'Content-Type': 'application/json'
            }
        })

        if (config.download) {
            result = result
            .then(async (res: any) => await res.blob())
            .then((blob: any) => {
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Wallet Transactions ${moment(startDate).format('MMM DD YYYY')}-${moment(endDate).format('MMM DD YYYY')}.xlsx`;
                link.target = "_blank";
                link.click();
                link.remove();
            })
        } else {
            result = result
            .then((resp: any) => resp.json())
            .then((json: any) => setLogs(json))
        }
        result.finally(() => config.download?
            setDownloadingLogs(false):
            setLoadingLogs(false)
        )
    }

    const viewLog = (log: any) => {
        if (log.method == 'instapay' && log.amount > 50000) {
            fetch(
                `${window.location.protocol}//${BASE_URL}/dashboard/wallet/instapay-transfers/${log.reference}`, {
                headers: {
                    Authorization: `Bearer ${token.access_token}`
                }
            })
            .then(res => res.json())
            .then(data => {
                setDialogTransactions(data)
                setDialogDetails(log)
            })
        } else {
            fetch(
                `${window.location.protocol}//${BASE_URL}/dashboard/wallet/wallet-logs/${log.reference}`, {
                headers: {
                    Authorization: `Bearer ${token.access_token}`
                }
            })
            .then(res => res.json())
            .then(data => {
                Swal.fire({
                    title: ['Successful', 'SUCCESS'].includes(data.status)? `${log.method != 'instapay'? 'Successfully': ''} Transferred Funds`: 'Transaction Details',
                    html: "<div>" +
                        `<b>Reference ID:</b> ${log.reference}<br/>` +
                        `<b>Transfer Date:</b> ${log.timestamp}<br/>` +
                        `<b>Amount:</b> ${log.amount.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}<br/>` +
                        `<b>Bank:</b> ${banks[log.bank_details.bank_code as BankCode]}<br/>` +
                        `<b>Account Name:</b> ${log.bank_details.account_name}<br/>` +
                        `<b>Account Number:</b> ${log.bank_details.account_number}<br/>` +
                        (data.status != 'Successful'? `<b>Details:</b> ${data.status}`: '') +
                    "</div>",
                    icon: ['Successful', 'SUCCESS'].includes(data.status)? "success": "info"
                })
            })
        }
    }

    return <>
        <Typography variant="h5" sx={{marginBottom: '1rem'}}>
            Wallet
        </Typography>
        <Grid2 container spacing={2} sx={{margin: '1rem 0'}} >
            <StyledCard sx={{marginBottom: '1rem', minWidth: '400px'}}>
                <CardContent>
                    <Typography variant="body2">
                        Balance{/* Total (as of {new Date().getHours() % 12 || 12}{new Date().getHours() >= 12 ? 'PM' : 'AM'}) */}
                    </Typography>
                    <Typography variant="h6">
                        {balance.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                    </Typography>
                </CardContent>
            </StyledCard>
        </Grid2>
        <Grid2 container spacing={2} sx={{margin: '1rem 0'}} >
            <StyledCard sx={{marginBottom: '1rem', minWidth: '400px'}}>
                <CardContent>
                    <Typography variant="h6">
                        Fund Transfer
                    </Typography>
                    <Grid2 container spacing={2} sx={{margin: '1rem 0'}}>
                        {/* <Grid2 size={{md: 6}} sx={{paddingRight: '1rem'}}>
                            <Typography fontWeight="bold">From:</Typography>
                            <Typography>DPay Wallet (Allbank 019-10-00242-3)</Typography>
                            <br/>
                            <Typography fontWeight="bold">To:</Typography>
                            * For Flexibility *
                            <TextField size="small" margin="dense" sx={{display: 'block'}} label="Account Name"/>
                            <TextField size="small" margin="dense" sx={{display: 'block'}} label="Account Number"/>
                            <FormControl size="small" margin="dense" sx={{display: 'inline-flex', minWidth: '200px'}}>
                                <InputLabel id="bank-label">Receiving Bank</InputLabel>
                                <Select labelId="bank-label" label="Receiving Bank" value={bank}>
                                    {Object.entries().map((key, value) => <MenuItem value={value}>{key}</MenuItem>)}
                                </Select>
                            </FormControl>
                            * Hard Coded *
                            <RadioGroup name="bank-accounts" onChange={e => setBankDetails(bankAccounts[e.target.value as BankAccountIndex])}>
                                {Object.entries(bankAccounts).map(([key, value]) =>
                                    <FormControlLabel
                                        value   = {key}
                                        control = {<Radio />}
                                        label   = {`${value?.account_name} (${banks[value?.bank as BankCode]} ${value?.account_number})`}
                                    />
                                )}
                            </RadioGroup>
                        </Grid2> */}
                        <Grid2 size={{md: 6}}>
                            <Typography fontWeight="bold">To:</Typography>
                            {/* For Flexibility */}
                            <RadioGroup name="bank-accounts" onChange={e => setBankDetails(bankAccounts[e.target.value as BankAccountIndex])}>
                                {Object.entries(bankAccounts).map(([key, value]) =>
                                    <FormControlLabel
                                        value   = {key}
                                        control = {<Radio />}
                                        label   = {`${value?.account_name} (${banks[(value?.bank || value?.bank_code) as BankCode]} ${value?.account_number})`}
                                    />
                                )}
                            </RadioGroup>
                            <br/>
                            <Typography fontWeight="bold">Amount:</Typography>
                            <TextField type="number" size="small" value={amount} onChange={e => setAmount(+e.target.value)} error={!!error} helperText={error}/>
                            <br/>
                            <br/>
                            <Typography fontWeight="bold">Transfer Method:</Typography>
                            <RadioGroup name="method" value={method} onChange={e => setMethod(bankDetails?.bank == '0'? 'intrabank': e.target.value)}>
                                <FormControlLabel disabled={bankDetails?.bank == '0'} value="instapay" control={<Radio />} label={`Instapay (near real-time, ${fee.toLocaleString(undefined, {minimumFractionDigits: 2})} per transaction, 50,000 limit per transaction)`} />
                                <FormControlLabel disabled={bankDetails?.bank == '0'} value="pesonet" control={<Radio />} label="Pesonet (1-3 business days, FREE)" />
                            </RadioGroup>
                            <br/>
                            <Typography fontWeight="bold">TOTAL</Typography>
                            <br/>
                            {bankDetails?.bank != '0' && method == 'instapay' && <>
                                <Typography>Amount: {amount.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Typography>
                                <Typography>Fee/s ({fee.toLocaleString(undefined, {minimumFractionDigits: 2})} x {Math.ceil(amount/50000)}): {(Math.ceil(amount/50000)*fee).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Typography>
                                <br/>
                            </>}
                            <Typography fontWeight="bold" fontStyle="italic">Total: {(amount + (
                                bankDetails?.bank == '0'? 0:
                                method == 'instapay'? Math.ceil(amount/50000): 0
                            )*fee).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Typography>
                            <StyledButton
                                size     = 'small'
                                variant  = "contained"
                                color    = "primary"
                                disabled = {!!error || (!bankDetails || !amount || !method) || loadingTransfer}
                                onClick  = {() => setOpenOtp(true)}>
                                    {loadingTransfer? <CircularProgress size='12px'/>:'Transfer'}
                            </StyledButton>
                            <Dialog open={openOtp} disableEscapeKeyDown>
                                <DialogContent>
                                    <DialogContentText>
                                        Enter OTP to verify fund transfer
                                        <br/>
                                    </DialogContentText>
                                    <DialogContent>
                                        <form onSubmit={e => {
                                            e.preventDefault()
                                            verifyOtp(confirmOtp)
                                        }}>
                                            {/* <Typography>Expires in {remainingTime}</Typography><br/> */}
                                            <TextField size="small" placeholder="******" label="Enter OTP" sx={{display: 'block'}} onChange={e => setConfirmOtp(e.target.value)}/><br/>
                                            <StyledButton size="small" variant="contained" type="submit" sx={{marginX: '1rem'}}>Verify</StyledButton>
                                            <StyledButton size="small" variant="contained" type="button" sx={{marginX: '1rem'}} color="warning" onClick={() => setOpenOtp(false)}>Cancel</StyledButton>
                                        </form>
                                    </DialogContent>
                                </DialogContent>
                            </Dialog>
                        </Grid2>
                    </Grid2>
                </CardContent>
            </StyledCard>
            <StyledCard>
                <CardContent>
                    <Grid2 container spacing={2} sx={{paddingX: '1rem'}} marginY="1rem">
                        <Grid2>
                            <TextField variant="outlined" size="small" type="date" label="Start Date" slotProps={{inputLabel: { shrink: true }}} value={startDate} onChange={e => setStartDate(e.target.value)}/>
                        </Grid2>
                        <Grid2>
                            <TextField variant="outlined" size="small" type="date" label="End Date"   slotProps={{inputLabel: { shrink: true }}} value={endDate} onChange={e => setEndDate(e.target.value)}/>
                        </Grid2>
                        <Grid2>
                            <StyledButton variant="contained" disabled={loadingLogs} sx={{marginTop: '-1px'}} onClick={() => getLogs()}>
                                {loadingLogs? <CircularProgress size="24px"/>: 'Apply'}
                            </StyledButton>
                        </Grid2>
                        <Grid2>
                            <StyledButton variant="contained" disabled={downloadingLogs} color="secondary" sx={{marginTop: '-1px'}} onClick={() => getLogs({download: true})}>
                                {downloadingLogs? <CircularProgress size="24px"/>: 'Download    '}
                            </StyledButton>
                        </Grid2>
                    </Grid2>
                    <Box height="300px" overflow="auto" marginY="1rem">
                        <Table stickyHeader size="small">
                            <TableHead sx={{width: '100%'}}>
                                <TableRow>
                                    <StyledTableCell>
                                        Transfer Date
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Reference
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        From
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        To
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Requested Amount
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Transferred Amount
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        Fee
                                    </StyledTableCell>
                                    {/* <StyledTableCell>
                                        Status
                                    </StyledTableCell> */}
                                    <StyledTableCell></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{width: '100%'}}>
                            {logs?.map((log, index) => (
                                <TableRow key={index}>
                                    <StyledTableCell>{log.timestamp || '-'}</StyledTableCell>
                                    <StyledTableCell>{log.reference || '-'}</StyledTableCell>
                                    <StyledTableCell>DPay Wallet</StyledTableCell>
                                    <StyledTableCell>{`${log.bank_details?.account_name} (${banks?.[log.bank_details?.bank_code as BankCode || '']} ${log.bank_details?.account_number})`}</StyledTableCell>
                                    <StyledTableCell>{log.amount?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2}) || '-'}</StyledTableCell>
                                    <StyledTableCell>{log.transferred_amount?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2}) || '-'}</StyledTableCell>
                                    <StyledTableCell>{log.total_fees?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2}) || '-'}</StyledTableCell>
                                    {/* <StyledTableCell color={log.status == 'Successful'? 'success': 'error'}>{log.status || '-'}</StyledTableCell> */}
                                    <StyledTableCell>
                                        <StyledButton size="small" variant="contained" onClick={() => viewLog(log)}>View</StyledButton>
                                    </StyledTableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        <Dialog maxWidth='md' open={!!dialogDetails}>
                            <DialogTitle>Fund Transfer Details</DialogTitle>
                            <DialogContent sx={{maxHeight: '500px'}}>
                                <Grid2 container spacing={3}>
                                    <Grid2 size="auto">
                                        <DialogContentText marginY={1}><b>Reference ID:</b><br/>{dialogDetails?.reference}</DialogContentText>
                                        <DialogContentText marginY={1}><b>Transfer Date:</b><br/>{dialogDetails?.timestamp}</DialogContentText>
                                        <hr/>
                                        <DialogContentText marginY={1}><b>Successful Transfers:</b><br/>{(dialogTransactions.filter((item) => item.ibftStatus == 'Successful' || item.status == 'SUCCESS')).length.toLocaleString(undefined, {maximumFractionDigits: 0})}</DialogContentText>
                                        <DialogContentText marginY={1}><b>Failed Transfers:</b><br/>{(dialogTransactions.filter((item) => item.ibftStatus == 'Failed' || item.status == 'FAILED')).length.toLocaleString(undefined, {maximumFractionDigits: 0})}</DialogContentText>
                                        <hr/>
                                        <DialogContentText marginY={1}><b>Requested Amount:</b><br/>{dialogDetails?.amount?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2}) || '0.00'}</DialogContentText>
                                        <DialogContentText marginY={1}><b>Transferred Amount:</b><br/>{dialogDetails?.transferred_amount?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2}) || '0.00'}</DialogContentText>
                                        <DialogContentText marginY={1}><b>Total Fees:</b><br/>{dialogTransactions.reduce((sum, item) => sum + +(item.ibftStatus == 'Successful' || item.status == 'SUCCESS'? item.fees || 0: 0), 0)?.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2}) || '0.00'}</DialogContentText>
                                        <hr/>
                                        <DialogContentText marginY={1}><b>Bank:</b><br/>{dialogDetails && dialogDetails.bank_details && banks[dialogDetails.bank_details.bank_code as BankCode]}</DialogContentText>
                                        <DialogContentText marginY={1}><b>Account Name:</b><br/>{dialogDetails && dialogDetails.bank_details && dialogDetails.bank_details.account_name}</DialogContentText>
                                        <DialogContentText marginY={1}><b>Account Number:</b><br/>{dialogDetails && dialogDetails.bank_details && dialogDetails.bank_details.account_number}</DialogContentText>
                                    </Grid2>
                                    <Grid2 size='grow' sx={{maxHeight: '450px', overflow: 'auto'}}>
                                        <Table stickyHeader size='small' sx={{width: '300px'}}>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Reference</StyledTableCell>
                                                    <StyledTableCell>Amount</StyledTableCell>
                                                    <StyledTableCell>Status</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {dialogTransactions.map(item => <TableRow>
                                                    <StyledTableCell>{item.senderRefid || item.reference_id}</StyledTableCell>
                                                    <StyledTableCell>{(+(item.tranAmount || item.amount || 0)).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}</StyledTableCell>
                                                    <StyledTableCell>
                                                        <Typography color={item.ibftStatus == 'Successful' || item.status == 'SUCCESS'? 'success': 'error'}>
                                                            {item.ibftStatus || item.status}
                                                        </Typography>
                                                    </StyledTableCell>
                                                </TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </Grid2>
                                </Grid2>
                            </DialogContent>
                            <DialogActions>
                                <StyledButton onClick={() => setDialogDetails(undefined)}>Close</StyledButton>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </CardContent>
            </StyledCard>
        </Grid2>
    </>
}

export default Wallet;